export const LogoMark = ({ className = "h-12 w-12" }) => (
  <img
    src="/images/logo.jpg"
    alt="IT Employees Federation logo"
    className={`shrink-0 rounded-full bg-white object-contain p-0.5 ${className}`}
    data-testid="logo-image"
  />
);

export const Logo = ({ light = false }) => (
  <div className="flex items-center gap-3" data-testid="site-logo">
    <LogoMark className={light ? "h-16 w-16" : "h-12 w-12"} />
    <div className="leading-tight whitespace-nowrap">
      <div className={`font-display text-[15px] sm:text-base font-extrabold tracking-tight ${light ? "text-white" : "text-navy"}`}>
        IT EMPLOYEES FEDERATION
      </div>
      <div className={`text-[10px] font-semibold uppercase tracking-[0.18em] ${light ? "text-emerald-300" : "text-leaf"}`}>
        Standing strong for IT employees
      </div>
    </div>
  </div>
);
